import { useNavigate } from 'react-router-dom';

export default function BugReportLink({ screen, context, returnTo }) {
  const navigate = useNavigate();
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '0.5rem',
      flexWrap: 'wrap',
      padding: '0.6rem 0 1.1rem',
    }}>
      <button
        onClick={() => navigate('/feedback', { state: { screen, type: 'feedback', context, returnTo } })}
        style={{
          background: 'none',
          border: '1px solid var(--border)',
          borderRadius: 4,
          padding: '0.5rem 1rem',
          fontFamily: "'Josefin Sans', sans-serif",
          fontSize: '0.6rem',
          letterSpacing: '0.12em',
          textTransform: 'uppercase',
          color: 'var(--text2)',
          cursor: 'pointer',
        }}
      >Share Feedback</button>

      <button
        onClick={() => navigate('/feedback', { state: { screen, type: 'bug', context, returnTo } })}
        style={{
          background: 'none',
          border: '1px solid rgba(239,68,68,0.3)',
          borderRadius: 4,
          padding: '0.5rem 1rem',
          fontFamily: "'Josefin Sans', sans-serif",
          fontSize: '0.6rem',
          letterSpacing: '0.12em',
          textTransform: 'uppercase',
          color: 'rgba(239,68,68,0.7)',
          cursor: 'pointer',
        }}
      >Report a Bug</button>
    </div>
  );
}
